import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploadingStatusBoxComponent } from './file-uploading-status-box.component';

@NgModule({
  declarations: [FileUploadingStatusBoxComponent],
  imports: [CommonModule],
  exports: [FileUploadingStatusBoxComponent],
})
export class FileUploadModule {}
